<template>
  <div>
    <v-btn v-on:click="clicked('From Test Component')" color="primary">Test Component</v-btn>
    </button>
  </div>
</template>
<script>
import clickMixin from "./clickMixin";
export default {
  name: "Test",
  mixins: [clickMixin]
};
</script>